// extracted by mini-css-extract-plugin
module.exports = {"sizesAccordion":"SizesSelector_sizesAccordion__1fYxN","sizesSheet":"SizesSelector_sizesSheet__WLgub"};